/**
 * Which filters make it into a table's history, and how the list is
 * kept. Pure: no storage, no React.
 */
import { hasFilterValue } from '../filterValue';

export const MAX_ENTRIES = 10;

// A filter left unchanged this long counts as one the user settled on,
// not a step on the way (typing "s", "sm", "smi" never gets recorded).
export const SETTLE_MS = 90 * 1000;

/** Only the entries that narrow the table, in a stable order. */
export const normaliseFilter = filter =>
  (filter || [])
    .filter(entry => entry?.id && hasFilterValue(entry.value))
    .map(({ id, value }) => ({ id, value }))
    .sort((a, b) => a.id.localeCompare(b.id));

/** Equal for two filters that narrow the table the same way. */
export const filterSignature = filter => JSON.stringify(normaliseFilter(filter));

/**
 * Puts `filter` at the top of `entries`: an equal entry already in the
 * list moves up rather than repeating, and the list keeps MAX_ENTRIES.
 * An empty filter changes nothing.
 */
export const addEntry = (entries, filter, now = Date.now()) => {
  const normalised = normaliseFilter(filter);
  if (normalised.length === 0) return entries;
  const signature = JSON.stringify(normalised);
  const others = (entries || []).filter(entry => JSON.stringify(entry.filter) !== signature);
  return [{ filter: normalised, savedAt: now }, ...others].slice(0, MAX_ENTRIES);
};
